/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { Translate, I18n } from 'react-redux-i18n'
import _ from 'lodash'

import './style.css'
import Button from '../../components/Button'
import { getOrderById, confirmOrder, cancelOrder } from '../../actions/order'
import { showAlert } from '../../actions/global'

type OrderConfirmProps={}
class OrderConfirm extends React.Component<OrderConfirmProps> {
  state = {
    shopEmail: '',
  }

  componentDidMount() {
    this.props.getOrderById(this.props.params.orderNo)
  }

  render() {
    const { params, confirmOrder, cancelOrder, order, shops, showAlert, location } = this.props
    const { shopEmail } = this.state

    var title = 'orderConfirm'
    var actionText = 'confirmOrder'
    var alertText = 'confirmOrderFailed'
    var action = confirmOrder
    if (location.pathname.indexOf('/orderCancel') === 0) {
      title = 'orderCancel'
      actionText = 'cancelOrder'
      alertText = 'cancelOrderFailed'
      action = cancelOrder
    }

    let shop
    if (order) {
      shop = _.find(shops, { id: order.shopId })
    }

    return <div className="order-container order-confirm">
      <Translate value={title} className="title" />
      <div className="info-row">
        <Translate value="inputEmailToConfrim" className="label" />
        <div className='input'>
          <input
            value={shopEmail}
            onChange={(event) => this.setState({ shopEmail: event.target.value })}
          />
        </div>
      </div>
      <Button type="action"
        text={I18n.t(actionText)}
        onClick={() => {
          if (shop && shopEmail === shop.email) {
            action(params.orderNo)
          } else {
            showAlert(
              I18n.t('incorrectEmail'),
              I18n.t(alertText),
              'error'
            )
          }
        }}
      />
    </div>
  }
}

const mapStateToProps = (state, ownProps) => ({
  order: state.order.current,
  shops: state.shop.shops,
  params: ownProps.match.params,
})
const mapDispatchToProps = (dispatch) => ({
  getOrderById: (orderNo) => dispatch(getOrderById(orderNo)),
  confirmOrder: (orderNo) => dispatch(confirmOrder(orderNo)),
  cancelOrder: (orderNo) => dispatch(cancelOrder(orderNo)),
  showAlert: (message, title, type) => dispatch(showAlert(message, title, type))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderConfirm)


// WEBPACK FOOTER //
// ./src/containers/OrderConfirm/index.js